// extracted by mini-css-extract-plugin
module.exports = {"container":"search_type_selector-module__container--2CHo_","wrapper":"search_type_selector-module__wrapper--1j6A3","dropdown":"search_type_selector-module__dropdown--1tf3a"};